<script>
  /* Executable code section of the program */
  //Components importation
  import BreaksCards from "./Cards/BreaksCards.svelte";
  import EmptyBreaks from "./EmptySections/EmptyBreaks.svelte";
  import ContainerSchedulMeets from "./ContainerSchedulMeets.svelte";
  //Tools importation
  import {isModalMeetingsOn,indexPositionData,userLocalData,invitedAttendeesArray,temporalData, isAlertOn, alertMessagge, isReloadNecessary} from "../apis/storage"
  import { updateOneDocument } from "../apis/APIS"

  //Auxiliary variables
  export let networkingData 
  export let indexPositionArray
  export let user

  //Destructuring variables from the prop object
  const {programmedBreaks} = networkingData;

  //function to display networking break modal
  const displayBreakModal = () =>{
    $isModalMeetingsOn = true
    $indexPositionData = indexPositionArray
    $invitedAttendeesArray=[]
  }
  //Function to display alert
  const displayAlert = () =>{
    $isAlertOn = true
  }
  
  //function to update break visibility
  const saveChanges = () =>{
    updateOneDocument("events",$temporalData,$temporalData.id)
    .then(()=>{
      $alertMessagge = "Changes were saved successfully."
      $isReloadNecessary = true
      displayAlert()
    })
    .catch(()=>{
      $alertMessagge = "An error occurred while saving changes.";
      displayAlert()
    })
    
  }

  /* End of the section */
</script>

<!-- Section to place the HTML code -->

  {#if programmedBreaks.length > 0}
  <div class="cardsContainer">
    {#if user[0].userRole !== "attendee"}
    <section class="addBreaksBtnCard">
      <button class="actionBtn" on:click={displayBreakModal}>Add Networking Break</button>
      <button class="actionBtn" on:click={saveChanges}>Save Changes</button>
    </section>
    {/if}
    {#each programmedBreaks as breakData,index}
      <BreaksCards breakdCardData = {breakData} indexBreakCard = {index} indexPositionArray ={indexPositionArray} user = {user}/>
    {/each}
  </div>
  {:else}
    <section class="addBreaksBtn">
      {#if user[0].userRole !== "attendee"}
      <button class="actionBtn" on:click={displayBreakModal}>Add Networking Break</button>
        {:else}
        <EmptyBreaks/>
      {/if}
    </section>
  {/if}

<!-- End of the section -->
<style>
  /* Section to place the code styles */
  /* Stylies for button to add break */
  .addBreaksBtn {
    width: 100%;
    height: 20vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .addBreaksBtnCard{
    width: 100%;
    padding: 15px;
    display: flex;
    justify-content: flex-end;
  }
  /* Cards Stylies */
  .actionBtn {
    margin: 0 10px;
    height: 50px;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 500;
    padding: 8px 16px;
    background-color: white;
    color: #111;
    border: 1px solid #444;
    transition: all 0.3s ease-in-out;
  }

  .actionBtn:hover {
    cursor: pointer;
    box-shadow: #000 0px 0px 5px;
    transform: scale(1.01);
    border-color: #fff;
    background-color: #ed2824;
    color: White;
  }
  .cardsContainer{
    background-color: #f4f4f4;
    width: 90%;
    padding: 20px;
    height: auto;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }
  /* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
    .cardsContainer{
      width: 100%;
      padding: 10px;
  }
  .addBreaksBtn{
    height: 10vh;
  }
  }
  /* /////////Cellphones ///////// */
  @media (max-width: 700px) {
    .cardsContainer{
      width: 100%;
      padding: 10px;
      flex-direction: column;
  }
  .addBreaksBtn{
    height: auto;
  }
  
  .addBreaksBtnCard{
    flex-direction: column;
  }
  .actionBtn{
    margin: 5px 0;
  }
  
  
  }

  /* End of the section */
</style>
